import jQuery from 'jquery';
window.jQuery = window.$ = jQuery;

import magnify from 'magnify';

const getRevealHtml = () => `
  <div class="reveal reveal-magnify" id="magnify-reveal" data-reveal>
    <span class="loader circle-spin absolute-center"></span>
    <button class="close-button" data-close aria-label="Close modal" type="button">
      <span aria-hidden="true"><i class="icon-close"></i></span>
    </button>
  </div>
`;

const magnifyItems = $('*[data-magnify]');
$(document).ready(() => {
  magnifyItems.each((index, el) => {
    $(el).on('click', event => {
      event.preventDefault();
      const imageUrl = $(el).data('magnify-src');
      let image = document.createElement('img');

      if ($('#magnify-reveal').length) $('#magnify-reveal').remove();
      $('body').append(getRevealHtml());
      const modal = new Foundation.Reveal($('#magnify-reveal'));
      $('#magnify-reveal').foundation('open');

      image.src = imageUrl;
      image.onload = () => {
        $(image).fadeOut(0);
        $('#magnify-reveal').append(image);

        $('#magnify-reveal .loader').fadeOut(400, () => {
          $(image).fadeIn(600).magnify({
            magnifiedWidth: 1200,
            magnifiedHeight: 1200,
            src: imageUrl,
          });
        });
      }
    });
  });

  $('#magnify-reveal').on('click', '.close-button', (event) => {
    event.preventDefault();
    $('#magnify-reveal').foundation('close');
  });
});
